import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Conditional className helper used by every shadcn/ui copy-in. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
